'use client'

import { useEffect, useState } from 'react'

import Link from 'next/link'

import IconButton from '@mui/material/IconButton'
import type { Theme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

import classnames from 'classnames'

import { Box, CircularProgress, Grid, Typography } from '@mui/material'

import Logo from '@components/layout/shared/Logo'

import { frontLayoutClasses } from '@layouts/utils/layoutClasses'

const Header = ({ styles }: { styles: any }) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])
  if (!mounted) return null

  return (
    <header className={`${frontLayoutClasses.header} ${isMobile ? styles.headerPrimaryMobile : styles.headerPrimary}`}>
      <div className={classnames(frontLayoutClasses.navbar, styles.navbar)}>
        <div className={classnames(frontLayoutClasses.navbarContent, styles.navbarContent)}>
          {isMobile ? (
            <Grid
              container
              alignItems='center'
              justifyContent='space-between' // Bagi kiri dan kanan
            >
              {/* Kiri: Hubungi Kami */}
              <Grid item>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <IconButton component='a' href='tel:+6282118546605' sx={{ p: 0 }}>
                    <img src='/images/icon/phone-call.png' alt='Phone' style={{ width: 16, height: 16 }} />
                  </IconButton>
                  <Typography
                    component='a'
                    href='tel:+6282118546605'
                    sx={{ color: 'white', textDecoration: 'none', fontSize: '0.8rem' }}
                  >
                    Hubungi Kami +62 821-1854-6605
                  </Typography>
                </Box>
              </Grid>

              {/* Kanan: WhatsApp */}
              <Grid item>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <IconButton
                    component='a'
                    href='https://wa.me/6282118546605'
                    target='_blank'
                    rel='noopener noreferrer'
                    sx={{ p: 0 }}
                  >
                    <img src='/images/icon/whatsapp.png' alt='Whatsapp' style={{ width: 16, height: 16 }} />
                  </IconButton>
                  <Typography
                    component='a'
                    href='https://wa.me/6282118546605'
                    target='_blank'
                    rel='noopener noreferrer'
                    sx={{ color: 'white', textDecoration: 'none', fontSize: '0.8rem' }}
                  >
                    WhatsApp
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          ) : (
            <Grid container alignItems='center' justifyContent='space-between'>
              {/* Logo di kiri */}
              <Grid item>
                <Link href='/'>
                  <Logo />
                </Link>
              </Grid>
              {/* Kontak di kanan */};
              <Grid
                item
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                  ml: 'auto'
                }}
              >
                {/* Phone */}
                <Grid item sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <IconButton component='a' href='tel:+6282118546605' sx={{ p: 0 }}>
                    <img src='/images/icon/phone-call.png' alt='Phone' style={{ width: 24, height: 24 }} />
                  </IconButton>
                  <Typography component='a' href='tel:+6282118546605' sx={{ color: 'white', textDecoration: 'none' }}>
                    Hubungi Kami +62 821-1854-6605
                  </Typography>
                </Grid>

                {/* Email */}
                <Grid item sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <IconButton component='a' href='mailto:eternalhometmc@gmail.com' sx={{ p: 0 }}>
                    <img src='/images/icon/email.png' alt='Email' style={{ width: 24, height: 24 }} />
                  </IconButton>
                  <Typography
                    component='a'
                    href='mailto:eternalhometmc@gmail.com'
                    sx={{ color: 'white', textDecoration: 'none' }}
                  >
                    E-Mail
                  </Typography>
                </Grid>

                {/* WhatsApp */}
                <Grid item sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <IconButton
                    component='a'
                    href='https://wa.me/6281290212573'
                    target='_blank'
                    rel='noopener noreferrer'
                    sx={{ p: 0 }}
                  >
                    <img src='/images/icon/whatsapp.png' alt='Whatsapp' style={{ width: 24, height: 24 }} />
                  </IconButton>
                  <Typography
                    component='a'
                    href='https://wa.me/6281290212573'
                    target='_blank'
                    rel='noopener noreferrer'
                    sx={{ color: 'white', textDecoration: 'none' }}
                  >
                    WhatsApp
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          )}
        </div>
      </div>
    </header>
  )
}

export default Header
